module.exports = __webpack_public_path__ + "static/media/to_east.63826efa.jpg";